import { isPlainObject, isArray } from 'remeda'

type NotificationData = { notification: string }

function isClient(value: unknown): value is Client {
  if (!isPlainObject(value)) return false
  return typeof value.objectId === 'string'
}

function isLikes(value: unknown): value is Array<Client> {
  if (!isArray(value)) {
    return false
  }

  return value.every((item) => isClient(item))
}

function isCheckInNotification(
  d: unknown
): d is { stationId: string; clientId: string } {
  if (!isPlainObject(d)) {
    return false
  }

  return typeof d.clientId === 'string' && typeof d.stationId === 'string'
}

function isClientNotification(d: unknown): d is { clientId: string } {
  if (!isPlainObject(d)) {
    return false
  }

  return typeof d.clientId === 'string'
}

function isConversationNotification(
  d: unknown
): d is { conversationId: string } {
  if (!isPlainObject(d)) {
    return false
  }

  return typeof d.conversationId === 'string'
}

function isNotificationData(value: unknown): value is NotificationData {
  if (!isPlainObject(value)) return false
  return 'notification' in value
}

function isWishlistNotification(
  d: unknown
): d is { likes: Array<{ client: { objectId: string } }> } {
  if (!isPlainObject(d)) {
    return false
  }

  return isLikes(d.likes)
}

export {
  isCheckInNotification,
  isClientNotification,
  isConversationNotification,
  isNotificationData,
}
